import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class GraphicService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiDataURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listGraphics = ({ categoryIDs, categoryID, page, max_results }) => {
    const request = {
      method: 'GET',
      url: '/graphics',
      params: {
        categoryIDs: categoryIDs && categoryIDs.join(','),
        category_id: categoryID,
        page,
        max_results: max_results || 30,
      },
    };
    return this.axios(request);
  };

  insertDbOfGraphic = (params) => {
    const { uploadKeys, subCat } = params;
    const request = {
      method: 'POST',
      url: '/graphics',
      data: {
        graphics: uploadKeys,
        category_id: subCat,
      },
    };
    return this.axios(request);
  };

  deleteGraphic = (id) => {
    const request = {
      method: 'DELETE',
      url: '/graphics',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  getUrlOfItem = (id) => {
    const request = {
      method: 'POST',
      url: '/graphics/download',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  getGraphicObjects = async (id) => {
    const request = {
      method: 'POST',
      url: '/graphics/download',
      data: {
        id,
      },
    };
    return this.axios(request).then(({ url }) =>
      this.axios({
        method: 'GET',
        url,
      }),
    );
  };

  searchGraphics = ({ categoriesId, page, lang, keyword }) => {
    const request = {
      method: 'GET',
      baseURL: config.apiSearchURL,
      url: '/graphics',
      params: {
        categoriesId,
        page,
        max_results: 30,
        lang,
        keyword,
      },
    };
    return this.axios(request);
  };
}

export default new GraphicService();
